import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext, useMemo } from 'react'

import type { FooterApi, ShowMode } from './Footer'
import { useFooter } from './Footer'

type LayoutContext = {
  footerApi: FooterApi
  noFullMode: boolean
}

const defaultShowMode: ShowMode = 'none'
const stubUpdateMode = () => defaultShowMode
const stubMode = () => {}

const stubContext: LayoutContext = {
  footerApi: {
    showMode: defaultShowMode,
    leftButton: stubUpdateMode,
    rightButton: stubUpdateMode,
    setFull: stubMode,
    setHalf: stubMode,
    setNone: stubMode,
  },
  noFullMode: false,
}

const LayoutContext = createContext<LayoutContext>(stubContext)

type LayoutContextProviderProps = {
  initialFooterState?: ShowMode
  noFullMode?: boolean
}

export const LayoutContextProvider: FC<PropsWithChildren<LayoutContextProviderProps>> = ({
  noFullMode = false,
  initialFooterState,
  children,
}) => {
  const footerApi = useFooter(initialFooterState, noFullMode)

  const context = useMemo(() => ({ footerApi, noFullMode }), [footerApi, noFullMode])

  return <LayoutContext.Provider value={context}>{children}</LayoutContext.Provider>
}

export const useLayoutContext = () => useContext(LayoutContext)
